import React from 'react';
import PageLayout from '../components/PageLayout';

const TermsConditions = () => (
  <PageLayout title="Terms & Conditions">
    <p><strong>Last Updated:</strong> May 29, 2026</p>
    <p>Please read these Terms and Conditions carefully before using the Chakna Point mobile application operated by Chakna Point ("us", "we", or "our").</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>1. Acceptance of Terms</h2>
    <p>By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the Service.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>2. Eligibility</h2>
    <p>You must be at least 18 years old to use this Service. By using the app, you represent and warrant that you are at least 18 years of age. Some products may have additional age restrictions (21+ for alcohol-related items where applicable by law).</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>3. User Accounts</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>You are responsible for maintaining the confidentiality of your account.</li>
      <li>You agree to provide accurate and complete information during registration.</li>
      <li>You are responsible for all activities that occur under your account.</li>
      <li>You must notify us immediately of any unauthorized use of your account.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>4. Orders and Payments</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>All orders are subject to availability and confirmation.</li>
      <li>Prices are listed in Indian Rupees (INR) and include applicable taxes unless stated otherwise.</li>
      <li>We reserve the right to refuse or cancel any order for any reason.</li>
      <li>Payment must be made at the time of order through available payment methods.</li>
      <li>Orders once confirmed cannot be modified. You may cancel before pickup.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>5. Pickup Points</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Orders must be picked up from the selected pickup point within the specified time.</li>
      <li>Uncollected orders after 2 hours may be cancelled without refund.</li>
      <li>Pickup point availability and operating hours may vary.</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>6. Product Information</h2>
    <p>We make every effort to display products accurately. However, we do not guarantee that product descriptions, images, pricing, or other content is accurate, complete, or error-free. We reserve the right to correct any errors and update information at any time.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>7. Intellectual Property</h2>
    <p>The Service and its original content, features, and functionality are owned by Chakna Point and are protected by international copyright, trademark, and other intellectual property laws.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>8. Prohibited Activities</h2>
    <ul style={{ paddingLeft: 20 }}>
      <li>Using the Service for any unlawful purpose</li>
      <li>Attempting to gain unauthorized access to our systems</li>
      <li>Interfering with or disrupting the Service</li>
      <li>Impersonating another person or entity</li>
      <li>Using automated systems to access the Service without permission</li>
    </ul>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>9. Limitation of Liability</h2>
    <p>In no event shall Chakna Point be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of the Service.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>10. Termination</h2>
    <p>We may terminate or suspend your account immediately, without prior notice, for any reason including breach of these Terms. Upon termination, your right to use the Service will cease immediately.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>11. Governing Law</h2>
    <p>These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Delhi, India.</p>

    <h2 style={{ fontSize: 18, fontWeight: 600, marginTop: 24, marginBottom: 8, color: '#2D1A00' }}>12. Contact Us</h2>
    <p>If you have questions about these Terms, please contact us at:</p>
    <p><strong>Email:</strong> support@chaknapoint.com<br /><strong>Phone:</strong> +91 98765 43210</p>
  </PageLayout>
);

export default TermsConditions;
